import { Box } from "@mui/material";
import React from "react";
import Image from "./Image";

function Gallery({ images, cols, orientation = "rounded" }) {
	if (!cols) {
		if (images.length === 1) {
			cols = 1;
		} else if (images.length === 2 || images.length === 4) {
			cols = 2;
		} else {
			cols = 3;
		}
	}
	return (
		<Box
			className="gallery"
			sx={(theme) => ({
				display: "flex",
				flexWrap: "wrap",
				marginX: theme.spacing(-4),
				"& figure.image": {
					width: `calc(99.99% / ${cols})`,
					marginTop: 0,
					marginBottom: theme.spacing(2),
					paddingX: theme.spacing(4),
				},
			})}
		>
			{images.map((img) => (
				<Image {...img} orientation={orientation} key={img.id} />
			))}
		</Box>
	);
}

export default Gallery;
